import React, { useState } from "react";
import Accordion from 'react-bootstrap/Accordion';
import RadioBox from './RadioBox';
import RadioBoxCondition from './radioBoxCondition';
import RadioboxRating from './radioboxRating';
import Checkbox1 from "./Checkbox1";
import CustomerPriceRange from "./CustomerPriceRange";
import { MdClose, MdFilterList, MdRefresh } from "react-icons/md";
import { FaTags, FaStar, FaBoxOpen } from "react-icons/fa";
import './Filters.css';
import { elakayAutoText } from "./dataElakay";


let __elakayInfoSource;
const __setElakayInfoSource = (infoSource) => { if (infoSource) __elakayInfoSource = infoSource; };
const __elakayText = (key, fallback) =>
  __elakayInfoSource?.laguangeElakay?.("frontElakayHardcodedText", __elakayInfoSource.languageAPI)?.["filterFitlerSU"]?.[key] || fallback;

// import { Link } from "react-router-dom";

const FiltersSU = props => {
    // const [filters, setFilters] = useState([]);
    // const [unCH, setUnCh] = useState(true);
    const [checked, setCheked] = useState([])
    const [useC, setUseC] = useState(false);
    const [newC, setNewC] = useState(false);
    const [stars1, setStars1] = useState(false);
    const [stars2, setStars2] = useState(false);
    const [stars3, setStars3] = useState(false);
    const [stars4, setStars4] = useState(false);
    const [stars5, setStars5] = useState(false);


    const allStars = {
        stars1, 
        setStars1,
        stars2, 
        setStars2,
        stars3, 
        setStars3,
        stars4, 
        setStars4,
        stars5, 
        setStars5,
    }
    const { 
        infoSource, 
        gridButon,
        getCalFilShop,
        handleFilters,
        click,
        setMyFilters
     } = props
    __setElakayInfoSource(infoSource);



const clickButton =()=>{
    setUseC(false)
    setNewC(false)
    setStars1(false)
    setStars2(false)
    setStars3(false)
    setStars4(false)
    setStars5(false)
    setMyFilters( {filters: {}})
    setCheked([])
    var inputs = document.querySelectorAll('.check2');
    for (var i = 0; i < inputs?.length; i++) {
        inputs[i].checked = false;
    }
    setMyFilters( {filters: {}})
 
}
    
    const FilterProduct = () => (
        <div className="SideDrawer1-filters-container-modern">
            <div className="SideDrawer1-filters-header">
                <div className="SideDrawer1-filters-header-content">
                    <div className="SideDrawer1-filters-icon-wrapper">
                        <MdFilterList className="SideDrawer1-filters-icon" />
                    </div>
                    <div>
                        <span className="SideDrawer1-filters-eyebrow">ELAKAY</span>
                        <h3 className="SideDrawer1-filters-title">
                            {infoSource.laguangeElakay('title', infoSource.languageAPI).filters} {__elakayText("t001", "Shop")}
                        </h3>
                    </div>
                </div>
                <button type="button" className="SideDrawer1-filters-close-btn" onClick={click} aria-label={elakayAutoText("h_c2db1e0ed9c89b", "Close filters")}>
                    <MdClose />
                </button>
            </div>

            {gridButon()}

            <div className="SideDrawer1-filters-body">
                <Accordion className="SideDrawer1-filters-accordion">
                    <Accordion.Item eventKey="284" className="SideDrawer1-filter-item">
                        <Accordion.Header className="SideDrawer1-filter-header">
                            <FaTags className="SideDrawer1-filter-header-icon" />
                            <span className="SideDrawer1-filter-header-text">
                                {infoSource.laguangeElakay('title', infoSource.languageAPI).filterPrice}
                            </span>
                        </Accordion.Header>
                        <Accordion.Body className="SideDrawer1-filter-body">
                            <div className="SideDrawer1-price-stack">
                                <RadioBox
                                    infoSource={infoSource}
                                    prices={getCalFilShop.prices && getCalFilShop.prices}
                                    handleFilters={filtersC => handleFilters(filtersC, "price")}
                                />
                                <CustomerPriceRange
                                    handleFilters={filtersC => handleFilters(filtersC, "price")}
                                />
                            </div>
                        </Accordion.Body>
                    </Accordion.Item>

                    <Checkbox1
                        infoSource={infoSource}
                        filters={getCalFilShop.filters && getCalFilShop.filters}
                        checked={checked}
                        setCheked={setCheked}
                        handleFilters={(filtersC, color) => handleFilters(filtersC, color)}
                    />

                    {handleFilters && (
                        <>
                            <Accordion.Item eventKey="384" className="SideDrawer1-filter-item">
                                <Accordion.Header className="SideDrawer1-filter-header">
                                    <FaBoxOpen className="SideDrawer1-filter-header-icon" />
                                    <span className="SideDrawer1-filter-header-text">
                                        {infoSource.laguangeElakay('title', infoSource.languageAPI).condition}
                                    </span>
                                </Accordion.Header>
                                <Accordion.Body className="SideDrawer1-filter-body">
                                    <RadioBoxCondition
                                        infoSource={infoSource}
                                        useC={useC}
                                        setUseC={setUseC}
                                        newC={newC}
                                        setNewC={setNewC}
                                        handleFilters={filtersC => handleFilters(filtersC, "condition")}
                                    />
                                </Accordion.Body>
                            </Accordion.Item>

                            <Accordion.Item eventKey="584" className="SideDrawer1-filter-item">
                                <Accordion.Header className="SideDrawer1-filter-header">
                                    <FaStar className="SideDrawer1-filter-header-icon" />
                                    <span className="SideDrawer1-filter-header-text">
                                        {infoSource.laguangeElakay('title', infoSource.languageAPI).rating}
                                    </span>
                                </Accordion.Header>
                                <Accordion.Body className="SideDrawer1-filter-body">
                                    <RadioboxRating
                                        infoSource={infoSource}
                                        allStars={allStars}
                                        handleFilters={filtersC => handleFilters(filtersC, "Stars")}
                                    />
                                </Accordion.Body>
                            </Accordion.Item>
                        </>
                    )}
                </Accordion>
            </div>

            <div className="SideDrawer1-filters-footer">
                <button type="button" className="SideDrawer1-clear-filters-btn" onClick={clickButton}>
                    <MdRefresh className="SideDrawer1-clear-icon" />
                    <span>{infoSource.laguangeElakay('Button', infoSource.languageAPI).clearAll}</span>
                </button>
            </div>
        </div>
    )
  

    return (
       
        FilterProduct()
      
    )
}
export default FiltersSU;
